import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { LogOut, Wallet, Send, Receipt, QrCode, History, User, TrendingDown, Menu, X } from 'lucide-react';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  if (!user) return null;

  const navLinks = [
    { to: '/dashboard', icon: Wallet, label: 'Dashboard' },
    { to: '/send', icon: Send, label: 'Send' },
    { to: '/invoice', icon: Receipt, label: 'Invoice' },
    { to: '/qr-payment', icon: QrCode, label: 'QR Pay' },
    { to: '/withdraw', icon: TrendingDown, label: 'Withdraw' },
    { to: '/transactions', icon: History, label: 'History' },
  ];

  return (
    <nav className="navbar-glass sticky top-0 z-50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-8">
            <Link to="/dashboard" className="flex items-center gap-2" data-testid="logo-link">
              <Wallet className="h-6 w-6 text-primary" />
              <span className="text-xl font-bold text-primary" style={{fontFamily: 'DM Sans'}}>SamaFlux</span>
            </Link>
            
            <div className="hidden md:flex items-center gap-2">
              {navLinks.map(({ to, icon: Icon, label }) => (
                <Link to={to} key={to} data-testid={`nav-${label.toLowerCase().replace(' ', '-')}`}>
                  <Button variant={isActive(to) ? 'default' : 'ghost'} size="sm" className="rounded-full">
                    <Icon className="h-4 w-4 mr-2" />
                    {label}
                  </Button>
                </Link>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Link to="/profile" data-testid="nav-profile" className="hidden sm:block">
              <Button variant="ghost" size="sm" className="rounded-full">
                <User className="h-4 w-4 mr-2" />
                {user.first_name}
              </Button>
            </Link>
            <Button onClick={handleLogout} variant="ghost" size="sm" className="rounded-full hidden sm:flex" data-testid="logout-button">
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
            <Button variant="ghost" size="sm" className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-button">
              {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t pb-4 pt-2 space-y-1" data-testid="mobile-menu">
            {navLinks.map(({ to, icon: Icon, label }) => (
              <Link to={to} key={to} onClick={() => setMobileOpen(false)} data-testid={`mobile-nav-${label.toLowerCase().replace(' ', '-')}`}>
                <Button variant={isActive(to) ? 'default' : 'ghost'} size="sm" className="w-full justify-start rounded-full">
                  <Icon className="h-4 w-4 mr-2" />
                  {label}
                </Button>
              </Link>
            ))}
            <Link to="/profile" onClick={() => setMobileOpen(false)} data-testid="mobile-nav-profile">
              <Button variant="ghost" size="sm" className="w-full justify-start rounded-full">
                <User className="h-4 w-4 mr-2" />
                Profile
              </Button>
            </Link>
            <Button onClick={handleLogout} variant="ghost" size="sm" className="w-full justify-start rounded-full" data-testid="mobile-logout-button">
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};